
import React, {Component} from 'react';
import { connect } from 'react-redux';
// Components
import Footer from 'components/presentational/Footer';
import ReplaySection from 'components/presentational/ReplaySection';
import FAQSection from 'components/containers/FAQSection';
import GTMPush from 'components/GTMPush'

// Functions
import {
    setSectionAsAnimated,
    setAudioToPlay,
    incrementAudioPlayCount,
    stopAudio
} from 'redux/actions';

import animation from './animation.js';
// Files
import './death-certificate.scss';

const mapStateToProps = state => {
    return {
        volumeIsOn: state.volumeIsOn,
        animatedSections: state.animatedSections,
        userInteracted: state.userInteracted,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSectionAsAnimated: (val) => dispatch(setSectionAsAnimated(val)),
        setAudioToPlay: (audioKey) => dispatch(setAudioToPlay(audioKey)),
        incrementAudioPlayCount: () => dispatch(incrementAudioPlayCount()),
        stopAudio: () => dispatch(stopAudio())
    };
};

class ConnectedDeathCertificate extends Component {
    constructor() {
        super();
        this.audio = React.createRef();

        // Bindigs
        this.handleReplayClick = this.handleReplayClick.bind(this);
        this.playAudio = this.playAudio.bind(this);
    }

    componentDidMount() {
        if (this.props.userInteracted && !this.props.animatedSections.some(el => el === this.props.id)) {
            this.animateSection();
        } else {
            // This will fire if we went back a page. If so, stop the current audio from playing.
            this.props.stopAudio();
        }
    }

    componentWillUpdate(nextProps) {
        if (nextProps.userInteracted && !this.props.userInteracted) {
            this.animateSection();
        }
    }

    componentWillUnmount() {
        this.props.setSectionAsAnimated(this.props.id);
    }

    playAudio() {
        this.props.setAudioToPlay('DeathCertificate');
        this.props.incrementAudioPlayCount();
    }

    animateSection() {
        animation(this.playAudio);
    }

    handleReplayClick() {
        this.animateSection();
    }

    render() {
        return (
            <div className="death-certificate">
            
                <GTMPush 
                  event="pageLoad" 
                  virtualPath={this.props.location.pathname} 
                  pageNo="03" 
                  pageName={this.props.pageName} 
                  quizAnswer="undefined" />
                  
                <div className="container">
                    <div className="row">
                        <div className="col-one-half">
                            <h1 className="death-certificate__heading heading-1">Step 2: Obtain the death certificate</h1>

                            <div className="death-certificate__content">
                                <p>In order to process your claim, we’ll need you to provide a copy of the death certificate. You can get a copy from the funeral home, and in most cases, that may be all the documentation you’ll need, unless one of the following scenarios applies to you. </p>

                                <p><strong>Select all that applies to you or select “None applies to me. Move to next section”.</strong></p>
                            </div>
                        </div>

                        <div className="col-one-half">
                            <FAQSection />
                        </div>
                    </div>
                    
                    <ReplaySection handleClick={this.handleReplayClick}/>
                </div>

                <Footer pageIndex={3}/>
            </div>
        )
    }
}

const DeathCertificate = connect(mapStateToProps, mapDispatchToProps)(ConnectedDeathCertificate);

export default DeathCertificate
